module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/036-b28d75952fcf8993c45bf743b6b91d06.jpg";